import i18n from "i18n";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { Collections } from "@graylog/enterprise-api";
import { defaultOnError } from "util/conditional/onError";
const INITIAL_DATA = {
  list: []
};
export const COLLECTION_GRANTEES_QUERY_KEY = "collection_grantees";
export const keyFn = (entityGRN) => [COLLECTION_GRANTEES_QUERY_KEY, entityGRN];
const fetchCollectionGrantees = async (entityGRN) => Collections.getCollectionSharing(entityGRN).then((responseArray) => ({
  list: responseArray
}));
const useCollectionGrantees = (entityGRN, { enabled } = { enabled: true }) => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: keyFn(entityGRN),
    queryFn: () => defaultOnError(
      fetchCollectionGrantees(entityGRN),
      i18n.t("notifications.fetch_collection_grantees_failed", { ns: "enterprise_collections" }),
      i18n.t("notifications.fetch_collection_grantees_failed_title", { ns: "enterprise_collections" })
    ),
    placeholderData: keepPreviousData,
    enabled
  });
  return {
    data: data != null ? data : INITIAL_DATA,
    isLoading,
    refetch
  };
};
export default useCollectionGrantees;
